export enum AvatarSizes {
  small = 'SMALL',
  medium = 'MEDIUM',
  large = 'LARGE',
}
